// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1pBnM","footer":"ChangeClinic_footer__1kgXu"};